import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { IonApp, IonButton, IonRouterOutlet } from '@ionic/angular/standalone';
import { environment } from '../environments/environment';
import { AppUpdateService } from './services/app-update.service';
import { User } from './apis/profil.api';
import { UserContextService } from './services/user-context.service';
import { Subscription } from 'rxjs';
import Brand from './services/ecosystems/brands/Brand';
import { setBrandByOrganisation } from './services/ecosystems/ECoSystemsHelper';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, IonRouterOutlet, IonButton],
})
export class AppComponent implements OnInit, OnDestroy {
  public appMode: string = environment.mode;
  public appModeClose: boolean = false;
  private appUpdateService = inject(AppUpdateService);

  public currentUser: User | null = null;
  private currentUserObservable: Subscription | null = null;
  private userContext = inject(UserContextService);

  public static currentBrand: Brand | null = null;

  getCurrentTheme(): string {
    if (!AppComponent.currentBrand) {
      return 'theme-acwa';
    }

    return 'theme-' + AppComponent.currentBrand?.getTheme();
  }

  constructor() {}

  redirectToStoryBook() {
    if (document.location.host.includes('localhost')) {
      window.open('http://localhost:6006/', '_blank');
    } else {
      document.location.href = '/storybook/?t=' + new Date().getTime();
    }
  }

  closeEnvironnementBar() {
    this.appModeClose = true;
  }

  ngOnInit() {
    this.appUpdateService.init();

    this.currentUserObservable = this.userContext.currentUser.subscribe(
      async (user) => {
        this.currentUser = user;

        if (this.currentUser === null) {
          setBrandByOrganisation(null);
        } else if (this.currentUser?.userCompanies?.length > 0) {
          setBrandByOrganisation(
            this.currentUser.userCompanies[0].company?.type,
          );
        }
      },
    );
  }

  ngOnDestroy() {
    if (this.currentUserObservable) {
      this.currentUserObservable.unsubscribe();
    }
  }
}
